import React from 'react';
import { Card } from '../components/ui/card';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Quote } from 'lucide-react';

const StoriesPage = () => {
  const stories = [
    {
      id: 1,
      name: 'Sarah Johnson',
      role: 'Machine Learning Engineer',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
      story: 'Duty AI helped me transition from academia to industry. Within 2 weeks of completing my AI interview, I was matched with my dream role at a leading AI startup.',
      achievement: 'Landed $180k role',
      location: 'San Francisco, CA'
    },
    {
      id: 2,
      name: 'Michael Chen',
      role: 'Senior Data Scientist',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
      story: 'The AI matching system is incredible. Instead of applying to hundreds of jobs, Duty AI connected me directly with companies looking for my specific skillset.',
      achievement: '3x income increase',
      location: 'Remote, US'
    },
    {
      id: 3,
      name: 'Priya Patel',
      role: 'AI Research Engineer',
      image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=400&fit=crop',
      story: 'As an international candidate, finding remote work was challenging. Duty AI made it seamless with their global platform and handled all the payment complexities.',
      achievement: 'Found remote work from India',
      location: 'Bangalore, India'
    },
    {
      id: 4,
      name: 'James Wilson',
      role: 'Software Engineer',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop',
      story: 'The referral program is amazing! I\'ve referred 5 friends and earned $1000 while helping them find great opportunities.',
      achievement: '$1000 in referrals',
      location: 'London, UK'
    },
    {
      id: 5,
      name: 'Emily Rodriguez',
      role: 'Product Manager',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop',
      story: "Duty AI's AI tools helped me optimize my profile and showcase my PM experience. Got multiple offers within a month!",
      achievement: 'Multiple offers in 30 days',
      location: 'Austin, TX'
    },
    {
      id: 6,
      name: 'Arun Kumar',
      role: 'Full Stack Developer',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
      story: 'The flexibility of contract work through Duty AI lets me work on exciting projects while maintaining work-life balance. Earning $150/hr doing what I love!',
      achievement: '$150/hr contracts',
      location: 'Toronto, Canada'
    }
  ];

  return (
    <>
      <Navbar />
      <div className="min-h-screen bg-[#F9FBF5] pt-20">
        <div className="max-w-7xl mx-auto px-6 py-16">
          {/* Hero */}
          <div className="text-center mb-16">
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Success Stories
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Real stories from professionals who found their dream roles through Duty AI
            </p>
          </div>

          {/* Stories Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            {stories.map((story) => (
              <Card key={story.id} className="p-8 hover:shadow-lg transition-shadow">
                <div className="flex items-start gap-6 mb-6">
                  <img
                    src={story.image}
                    alt={story.name}
                    className="w-20 h-20 rounded-full object-cover"
                  />
                  <div className="flex-1">
                    <h3 className="text-xl font-bold text-gray-900">{story.name}</h3>
                    <p className="text-gray-600">{story.role}</p>
                    <p className="text-sm text-gray-500 mt-1">{story.location}</p>
                  </div>
                  <Quote className="w-8 h-8 text-[#B8C4AD]" />
                </div>
                
                <p className="text-gray-700 mb-4 italic">"{story.story}"</p>
                
                <div className="bg-[#F1F5E6] rounded-lg px-4 py-2 inline-block">
                  <span className="text-[#0A3900] font-semibold text-sm">
                    {story.achievement}
                  </span>
                </div>
              </Card>
            ))}
          </div>

          {/* CTA Section */}
          <div className="bg-[#082900] rounded-2xl p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-4">Ready to Write Your Success Story?</h2>
            <p className="text-lg mb-8 opacity-90">
              Join thousands of professionals who found their dream jobs through Duty AI
            </p>
            <button 
              className="bg-white text-[#0A3900] px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
              onClick={() => window.location.href = '/explore'}
            >
              Start Your Journey
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default StoriesPage;